// extracted by mini-css-extract-plugin
export default {"Section":"S_4NLc6S","title":"agKP7dN9"};